import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';

import { getOrderLabels, getOrderIcon } from 'helpers/order';
import IntlDate from "../../IntlDate";
import Button from "react-bootstrap/lib/Button";

class InvoicesList extends React.Component {
  gotoInvoice = invoiceId => {
    const { appIntl, history } = this.props;
    history.push(appIntl.urlPrefix + `account/settings/invoices/${invoiceId}`);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      title
    } = this.props;

    return list.data.count ? (
      <Col xs={12} md={6} className="m-t-20 grid-item">
        <div className="widget-11 card no-margin b-grey b-a">
          <div className="card-header p-t-20 p-l-15">
            <div className="card-title">{title}</div>
          </div>
          <div>
            <table className="table table-condensed table-hover">
              <tbody>
                {list.data.list.map((invoice, i) => {
                  return i < 5 ? (
                    <tr key={invoice.id} style={{cursor: "pointer"}} onClick={() => this.gotoInvoice(invoice.id)}>
                      <td className="font-secondary all-caps fs-12">
                        <i className="fad fa-file-alt" /> {invoice.number}
                      </td>
                      <td className="text-right">
                        {invoice.payment === 'bill' ? <span className="hint-text small">Fällig am: <IntlDate date={invoice.payment_info.bill_payment.due_date} /></span> : null}
                      </td>
                      <td className="text-right">
                        <span className="font-secondary fs-18">
                          <FormattedNumber value={invoice.sum_gross} style="currency" currency={invoice.currency} />
                        </span>
                      </td>
                    </tr>
                  ) : null;
                })}
              </tbody>
            </table>
          </div>
          <div className="p-b-20">
            <p className="no-margin text-center">
              <Button href={appIntl.urlPrefix + 'account/settings/invoices'} className="text-master">
                <i className="fa fa-bars"/> {messages.view_all}
              </Button>
            </p>
          </div>
        </div>
      </Col>
    ) : <Col xs={12} md={6} className="m-t-20 grid-item">
      <div className="widget-11 card no-margin b-grey b-a">
        <div className="card-header p-t-20 p-l-15">
          <div className="card-title">{title}</div>
        </div>
        <div>
          <p className="no-margin text-center">{messages.no_invoices_to_display}</p>
        </div>
        <div className="p-b-20 p-t-10">
          <p className="no-margin text-center">
            <Button href={appIntl.urlPrefix + 'account/settings/invoices'} className="text-master">
              <i className="fa fa-bars"/> {messages.view_all}
            </Button>
          </p>
        </div>
      </div>
    </Col>;;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(InvoicesList)));
